<template>
<div>

    <side-bar></side-bar>
 <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
   <!-- Navbar -->
   <top-navbar></top-navbar>
   <!-- End Navbar -->
  
     

   <dashboard-content @click="toggleSidebar">

</dashboard-content>
  </main>
 
 


</div>
 
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './TopNavbar.vue'
import SideBar from './SideBar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    SideBar
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
